<template>
    <EditingDialog 
        :context="context + 'ShippingRows'"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col cols="8">
                <!-- Entry Type selector chips for LABEL COMPANIES -->
                <!-- why dependent on local object, company is a global setting -->
                <!-- this.$store.getters.getSelectedOverAllCompany.context == 2 = LABEL -->
                <!-- <template v-if="this.searchObject.company == 'label'"> -->
                <template v-if="companyIsLabel">
                    <v-chip
                        v-for="(item, index) in entryTypesForLabelCompanies"
                        :key="index"
                        @click="changeEntryTypes(item)"
                        :color="getSearchType == item.search ? 'selectedChip' : 'standard'"
                        class="ml-2 pl-4 pr-4"
                    >
                        <div :alvqa="alvqa + '-entry-type-chip-' + item.search">
                            {{ item.text }}
                        </div>
                    </v-chip>
                </template>

                <!-- Entry Type selector chips for PUBLISHING COMPANIES -->
                <template v-else>
                    <v-chip 
                        v-for="(item, index) in entryTypesForPublishingCompanies"
                        :key="index"
                        @click="changeEntryTypes(item)"
                        :color="getSearchType == item.search ? 'selectedChip' : 'standard'"
                        class="ml-2 pl-4 pr-4"
                    >
                        <div :alvqa="alvqa + '-entry-type-chip-' + item.search">
                            {{ item.text }}
                        </div>
                    </v-chip>
                </template>
                </v-col>
            </v-row>

            <v-row>

                <v-col cols="12">
                <!-- Product TITLE: can be Label (Track, Release) or Publishing (Work, Sheet, Release) -->
                <!-- returnObject=false and itemValue, otherwise the Autocomplete returns the whole object -->
                
                <!-- ADD ROW - PRODUCT autocomplete search -->
                <template v-if="(getSearchType != 'label/freetext') && (getSearchType != 'publishing/freetext') && (isNewSearch)">
                    <BaseEditPageAutocomplete 
                        :context="context +'ShippingRows'"
                        field="Title"
                        :label="autocompleteSearchCaption"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-title'"
                        :returnObject="false"
                        itemValue="alvId"
                    >
                        <!-- selected product -->
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-shipping-shippingrows-title'">
                                {{ titleSelection(item) }}
                            </div>
                        </template>

                        <!-- dropdown list of options -->
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-shipping-shippingrows-title-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-shipping-shippingrows-title-dropdown-text-' + items.alvId">
                                    {{ titleDropdown(items) }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </template>

                <!-- ADD ROW - FREETEXT entry -->
                <template v-else-if="isNewSearch">
                    <BaseEditPageTextField 
                        :context="context +'ShippingRows'"
                        field="Title"
                        :clearable="true"
                        rules="required"
                        :label="$t('lang_GENERIC_CAPTION_FREETEXT')"
                        :alvqa="alvqa + '-textfield-freetext'"
                        :withMargin="false"
                    />
                </template>

                <!-- EDIT ROW (TITLE READ-ONLY) FOR PRODUCTS AND FREETEXT -->
                <template v-else>
                    <BaseEditPageTextField 
                        :context="context +'ShippingRows'"
                        field="Title"
                        :clearable="false"
                        :label="getSearchCaption"
                        :alvqa="alvqa + '-textfield-freetext'"
                        :withMargin="false"
                        :disabled="true"
                    />
                </template>

                </v-col>

            </v-row>

            <v-row>

                <!-- Batch -->
                <v-col cols="4" v-if="getSearchType == 'label/releases' || getSearchType == 'publishing/releases'">
                    <BaseEditPageDropdown 
                        :context="context +'ShippingRows'"
                        field="Batch"
                        :items="dropdownBatches" 
                        :label="$t('lang_ERP_SHIPPING_CAPTION_BATCH')"
                        :selection="true"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-batch'"
                    />
                </v-col>

                <!-- Quantity -->
                <v-col cols="4">
                    <BaseEditPageTextField 
                        :context="context +'ShippingRows'"
                        field="Quantity"
                        :label="$t('lang_ERP_SHIPPING_CAPTION_QUANTITY')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-quantity'"
                    />
                </v-col>

                <!-- Price -->
                <v-col cols="4">
                    <BaseEditPageTextField 
                        :context="context +'ShippingRows'"
                        field="Price"
                        :label="$t('lang_ERP_SHIPPING_CAPTION_ITEM_PRICE') + ' ' + $store.getters.getSelectedCurrency"
                        :withMargin="false"
                        rules="amountMaxTwoDigits"
                        :alvqa="alvqa + '-textfield-price'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>
<script>

import BaseEditPageDropdown             from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField            from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete         from '@/components/_editForm/BaseEditPageAutocomplete'
import EditingDialog                    from '@/components/_dialogs/EditingDialog'
import { DropdownErpShippingBatches }   from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ShippingRowsEditPanelDialog",
    components: {
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageAutocomplete,
        EditingDialog
    },
    data() {
        return {
            context: "Shipping",
            alvqa: "erp-shipping-edit-panel-shippingrows-dialog",
            searchObject: {
                // when dialog is opened from an existing shipping row, set searchObject based on data
                // set all to null, and have a new method to populate with condition from above, mounted()?
                company: this.$store.getters.getSelectedOverAllCompany.context == 2 ? "label" : "publishing",
                search: null,
                caption: ""
            },
        }
    },
    created() {
        let searchType = this.$store.getters.getShippingShippingRowsTitleSearch
        if (this.companyIsLabel) {
            let result = this.entryTypesForLabelCompanies.find(function(post, index) {
                if(post.search == searchType)
                    return true;
            });
            if(result === undefined) return ''
            else this.searchObject.caption = result.caption
        } else {
            let result = this.entryTypesForPublishingCompanies.find(function(post, index) {
                if(post.search == searchType)
                    return true;
            });
            if(result === undefined) return ''
            else this.searchObject.caption = result.caption
        }
    },
    computed: {
        autocompleteSearchCaption() { 
            return this.getSearchCaption // this.$t(this.searchObject.caption)
        },
        companyIsLabel() {
            return this.$store.getters.getSelectedOverAllCompany.context == 2 ? true : false
        },
        dropdownBatches() { 
            return DropdownErpShippingBatches
        },
        entryTypesForLabelCompanies() {
            return [
                {   text: this.$t('lang_ERP_SHIPPING_CAPTION_SHIPPINGROWS_DIALOG_SEARCH_LABEL_RELEASES'), 
                    search: "label/releases",
                    caption: "lang_ERP_SHIPPING_CAPTION_SHIPPINGROWS_DIALOG_SEARCH_LABEL_RELEASES" },

                {   text: this.$t('lang_GENERIC_CAPTION_FREETEXT'), 
                    search: "label/freetext",
                    caption: "lang_GENERIC_CAPTION_FREETEXT" },
            ]
        },
        entryTypesForPublishingCompanies() {
            return [
                {   text: this.$t('lang_PUBLISHING_CAPTION_PROJECTS'), 
                    search: "publishing/releases",
                    caption: "lang_PUBLISHING_CAPTION_PROJECTS" },

                {   text: this.$t('lang_GENERIC_CAPTION_FREETEXT'), 
                    search: "publishing/freetext",
                    caption: "lang_GENERIC_CAPTION_FREETEXT" },
            ]
        },
        getSearchType() {
            let type = this.$store.getters.getShippingShippingRowsTitleSearch
            return type
        },
        getSearchCaption() {
            let type = this.getSearchType
            if (this.companyIsLabel) {
                let result = this.entryTypesForLabelCompanies.find(function(post, index) {
                    if(post.search == type)
                        return true;
                })
                if(result === undefined) return ''
                else return this.$t(result.caption)
            } else {
                let result = this.entryTypesForPublishingCompanies.find(function(post, index) {
                    if(post.search == type)
                        return true;
                })
                if(result === undefined) return ''
                else return this.$t(result.caption)
            }
        },
        getTitleOfExistingRow() {
            return this.$store.getters.getShippingRowsDetailsTitle
        },
        isNewSearch() {
            let isNewSearch = this.$store.getters.getShippingShippingRowsIsNewSearch
            return isNewSearch        
        }
    },
    methods: {
        changeEntryTypes(item) {
            if (this.isNewSearch) {
                this.$store.commit('setShippingShippingRowsDetailsTitle', null)
                this.$store.commit('setShippingShippingRowsTitleOptions', [])
                this.$store.commit('setShippingShippingRowsTitleSearch', item.search)
                this.$store.commit('setShippingShippingRowsDetailsType', item.search)
            }
        },
        
        titleDropdown(item) {
            if (this.companyIsLabel) {
                if (this.getSearchType == "label/tracks") {
                    return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelTracks(item) + ')';
                } else if (this.getSearchType == "label/releases") {
                    return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelReleases(item) + ')'
                }
            } else {
                if (this.getSearchType == "publishing/works") {
                    return item.title + ' (' + item.gemaNumber + ')';
                } else if (this.getSearchType == "publishing/sheets") {
                    return item.title;
                } else if (this.getSearchType == "publishing/releases") {
                    return item.title;
                }
            }
        },

        titleSelection(item) {
            if (item.connectionId) { 
                // EDIT ROW - do I need to write type to store here?
                // this.$store.commit('setShippingShippingRowsDetailsConnectionId', item.connectionId)
                // this.$store.commit('setShippingShippingRowsTitleSearch', this.getSearchType)
                // TODO_PT: improve to connectionObject.ean/isrc/catalogNumber/workId...etc
                return item.title + ' (' + item.connectionId + ')'; 
            } else {  
                // NEW ROW - do I need to write type to store here?
                this.$store.commit('setShippingShippingRowsTitleSearch', this.getSearchType)
                this.$store.commit('setShippingShippingRowsDetailsConnectionId', item.alvId)
                this.$store.commit('setShippingShippingRowsDetailsType', this.getSearchType)
                this.$store.commit('setShippingShippingRowsDetailsProductId', item.catalogueNumber)
                switch (this.getSearchType) {
                    case "label/releases":
                        if (item.catalogueNumber) return item.title + ' (' + item.catalogueNumber + ')'
                            else return item.title
                        break;                             
                    case "publishing/releases":
                        return item.title
                        break;               
                    default:
                        return "Error in type of shipping row"
                        break;
                }
            }
        },
    }
}
</script>